import { DictionaryErrorType, IDictionaryItem } from "./types";
import useDictionary from "./useDictionary";

// Still consumed by the legacy (non-redesign) VAST creative form.
export const MREC_DICTIONARY_ITEMS = [
  { id: "_6d0x5d0", eid: NaN, title: "6:5" },
];

function useAspectRatioDictionary(): [IDictionaryItem[], DictionaryErrorType] {
  return useDictionary("aspect-ratio");
}

export default useAspectRatioDictionary;
